export type SkillUpdateInstallation = {
  syncStartedAt: number | null;
  updateRequestedAt: number | null;
  baselineUnavailable?: boolean | null;
  candidateHash: string | null;
  lastSyncedAt?: number | null;
  lastError: string | null;
  source?: {
    checkExecutionId: string | null;
    checkRequestedAt: number | null;
    checkError: string | null;
    lastError?: string | null;
    lastCheckedAt: number | null;
  };
};

type Status = {
  label:
    | "Not checked"
    | "Checking"
    | "Updating"
    | "Update available"
    | "Up to date"
    | "Error";
  color: "gray" | "sky" | "orange" | "green" | "red";
  detail: string;
};

export function skillUpdateStatus(
  installation: SkillUpdateInstallation,
  syncTimedOut: boolean
): Status {
  const error =
    installation.lastError ??
    installation.source?.checkError ??
    installation.source?.lastError;
  if (
    (installation.syncStartedAt !== null && !syncTimedOut) ||
    installation.updateRequestedAt !== null
  )
    return {
      label: "Updating",
      color: "sky",
      detail: "Updating from Git…",
    };
  if (
    installation.source?.checkExecutionId ||
    installation.source?.checkRequestedAt != null
  )
    return {
      label: "Checking",
      color: "sky",
      detail: "Checking for updates…",
    };
  if (syncTimedOut)
    return {
      label: "Error",
      color: "red",
      detail: "The Git sync timed out. Resync from Git to try again.",
    };
  if (error || installation.baselineUnavailable)
    return {
      label: "Error",
      color: "red",
      detail:
        error ??
        "The previously installed Git version is unavailable. Apply an update to restore syncing.",
    };
  if (installation.candidateHash)
    return {
      label: "Update available",
      color: "orange",
      detail: "New version ready to review",
    };
  if (installation.source?.lastCheckedAt)
    return {
      label: "Up to date",
      color: "green",
      detail: "No updates found",
    };
  return {
    label: "Not checked",
    color: "gray",
    detail: "Updates haven’t been checked yet",
  };
}
